import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import {
  Info, InfoContainerBase, InfoIconContainerBase,
} from '.';
import { ErrorIcon, useStyledTheme } from '../../..';
import { Flex } from '../Flex';

const IconContainer = styled(Flex)`${({ theme }) => `
  width:${theme.padding[6]};
`}`;

const DefaultContainer = styled(InfoContainerBase)`${({ theme }) => `
    background: ${theme.colours.danger[2]};
`}`;

const DefaultIconContainer = styled(InfoIconContainerBase)`${({ theme }) => `
    background: ${theme.colours.danger[1]};
`}`;

export function ErrorInfo({ children }: PropsWithChildren) {
  const theme = useStyledTheme();

  return (
    <Info
      Container={DefaultContainer}
      IconContainer={DefaultIconContainer}
      icon={<IconContainer><ErrorIcon fill={theme.colours.danger[1]} /></IconContainer>}
    >
      {children}
    </Info>
  );
}
